import React from "react";

// A quiet, living backdrop for the footer (behind its content, never in the way of a click):
// two soft waves that drift along the top edge, a light that travels along that edge, and small
// glowing lights that rise slowly and fade out like lanterns. Pure CSS motion (see .ffx-* in App.css).

// Fixed numbers, not random ones, so the lights are the same on every visit and every render.
const ORBS = [
  { left: 6, size: 10, duration: 19, delay: 0, sway: 24, hue: "cyan" },
  { left: 13, size: 6, duration: 23, delay: 6, sway: -18, hue: "violet" },
  { left: 21, size: 12, duration: 26, delay: 12, sway: 30, hue: "cyan" },
  { left: 29, size: 7, duration: 20, delay: 3, sway: -26, hue: "cyan" },
  { left: 37, size: 9, duration: 24, delay: 9, sway: 20, hue: "violet" },
  { left: 45, size: 5, duration: 18, delay: 15, sway: -14, hue: "cyan" },
  { left: 52, size: 11, duration: 27, delay: 4, sway: 28, hue: "cyan" },
  { left: 60, size: 7, duration: 21, delay: 11, sway: -22, hue: "violet" },
  { left: 67, size: 9, duration: 25, delay: 1, sway: 18, hue: "cyan" },
  { left: 74, size: 6, duration: 19, delay: 8, sway: -30, hue: "cyan" },
  { left: 81, size: 12, duration: 28, delay: 14, sway: 26, hue: "violet" },
  { left: 88, size: 7, duration: 22, delay: 5, sway: -16, hue: "cyan" },
  { left: 94, size: 9, duration: 24, delay: 10, sway: 22, hue: "cyan" },
];

// Two whole periods of a gentle wave, so sliding it by half its own width loops without a seam.
const WAVE = "M0 40 q75 -34 150 0 t150 0 t150 0 t150 0 t150 0 t150 0 t150 0 t150 0 V120 H0 Z";

export default function FooterFX() {
  return (
    <div className="ffx absolute inset-0 overflow-hidden pointer-events-none" aria-hidden="true">
      <svg className="ffx-wave ffx-wave-a" viewBox="0 0 1200 120" preserveAspectRatio="none"><path d={WAVE} /></svg>
      <svg className="ffx-wave ffx-wave-b" viewBox="0 0 1200 120" preserveAspectRatio="none"><path d={WAVE} /></svg>
      <div className="hero-fx-edge absolute inset-x-0 top-0" />
      {ORBS.map((o, i) => (
        <span
          key={i}
          className={`ffx-orb ffx-orb-${o.hue}`}
          style={{ left: `${o.left}%`, width: o.size, height: o.size, "--dur": `${o.duration}s`, "--del": `${o.delay}s`, "--sway": `${o.sway}px` }}
        />
      ))}
    </div>
  );
}
